// src/config/site.js

export const SITE_URL = 'https://coalab.us';
export const getVerifyUrl = (certId) => `${SITE_URL}/certificados/${certId}`;

// ── Certificate types & pricing ───────────────────────────────────────────────
// Price in USD. Update here and it propagates to pricing section, payment step, and admin panel.
export const CERT_TYPES = [
  {
    key: 'simple',
    name: { en: 'Simple COA', de: 'Einfaches ZA' },
    desc: { en: 'Basic certificate with visual and standard parameters.', de: 'Basiszertifikat mit visuellen und Standardparametern.' },
    price: 180,
    features: {
      en: ['Visual inspection', 'Basic parameters', 'QR verification', 'PDF download', 'Admin review'],
      de: ['Sichtprüfung', 'Grundparameter', 'QR-Verifizierung', 'PDF-Download', 'Admin-Prüfung'],
    },
  },
  {
    key: 'hplc',
    name: { en: 'HPLC COA', de: 'HPLC ZA' },
    desc: { en: 'High-performance liquid chromatography analysis certificate.', de: 'Zertifikat für Hochleistungsflüssigkeitschromatographie-Analyse.' },
    price: 300,
    features: {
      en: ['HPLC analysis', 'Purity & assay', 'Identification (IR)', 'QR verification', 'PDF download', 'Admin review'],
      de: ['HPLC-Analyse', 'Reinheit & Gehalt', 'Identifizierung (IR)', 'QR-Verifizierung', 'PDF-Download', 'Admin-Prüfung'],
    },
    popular: true,
  },
  {
    key: 'gmp',
    name: { en: 'GMP COA', de: 'GMP ZA' },
    desc: { en: 'Full GMP-compliant certificate for pharmaceutical products.', de: 'Vollständiges GMP-konformes Zertifikat für pharmazeutische Produkte.' },
    price: 3000,
    features: {
      en: ['Full GMP compliance', 'HPLC + GC analysis', 'Microbiology panel', 'Residual solvents', 'Heavy metals', 'QR verification', 'PDF download', 'Priority review'],
      de: ['Volle GMP-Konformität', 'HPLC + GC-Analyse', 'Mikrobiologie-Panel', 'Restlösemittel', 'Schwermetalle', 'QR-Verifizierung', 'PDF-Download', 'Prioritätsprüfung'],
    },
  },
  {
    key: 'karlfisher',
    name: { en: 'Karl Fischer COA', de: 'Karl-Fischer ZA' },
    desc: { en: 'Water content determination by Karl Fischer titration.', de: 'Wassergehaltsbestimmung durch Karl-Fischer-Titration.' },
    price: 80,
    features: {
      en: ['Karl Fischer titration', 'Water content (%)', 'Moisture analysis', 'QR verification', 'PDF download', 'Admin review'],
      de: ['Karl-Fischer-Titration', 'Wassergehalt (%)', 'Feuchtigkeitsanalyse', 'QR-Verifizierung', 'PDF-Download', 'Admin-Prüfung'],
    },
  },
];

// ── Crypto payment wallets ────────────────────────────────────────────────────
// Update these with your real wallet addresses before going live.
export const CRYPTO_WALLETS = [
  {
    key: 'usdt',
    name: 'USDT',
    network: 'TRC-20 (Tron)',
    address: 'TRGzSWk59mqZz8bW2Zt6aeL49SCdoDFjLp',
    icon: '₮',
    color: '#26A17B',
    explorerUrl: 'https://tronscan.org/#/transaction/',
    explorerName: 'TronScan',
  },
  {
    key: 'btc',
    name: 'Bitcoin',
    network: 'BTC',
    address: 'bc1q6z6fnal7hzevx3853aum5ddyg3msnpjrwh64qm',
    icon: '₿',
    color: '#F7931A',
    explorerUrl: 'https://blockchair.com/bitcoin/transaction/',
    explorerName: 'Blockchair',
  },
];
